import { findAll, isUnattached, setAttached } from "./dom";

export default () =>
  findAll(document, ".gk-scroll-bottom")
    .filter((element) => isUnattached("scroll_bottom", element))
    .map((element) => setAttached("scroll_bottom", element))
    .forEach((element) => {
      element.scrollTop = element.scrollHeight;
    });
